import React from "react";
import {
    TopToolbar, sanitizeListRestProps, CreateButton, TextField,
    // ExportButton
} from "react-admin";
import {makeStyles} from "@material-ui/core/styles";
import {cleanHTML} from "../../../functions/functions";

const useStyles = makeStyles({
    body:{
        maxHeight: "5rem",
        overflow: "hidden",
        display: "block"
    },
    popoverWrapper: {
        position: 'relative',
        '& .popover__content-wrapper': {
            opacity: 0,
            visibility: 'hidden',
            position: 'absolute',
            right: '100%',
            transform: 'translate(0, 10px)',
            backgroundColor: '#fff',
            padding: '20px 0 20px 20px',
            boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
            borderRadius: 8,
            width: 'auto',
        },
        '& .arrow': {
            position: 'absolute',
            zIndex: -1,
            content: '""',
            right: -8,
            top: 15,
            borderStyle: 'solid',
            borderWidth: ' 10px 0  10px 10px',
            borderColor: 'transparent transparent  transparent #fff',
            transitionDuration: '0.3s',
            transitionProperty: 'transform'
        },
        '&:hover .popover__content-wrapper': {
            zIndex: 10,
            opacity: 1,
            visibility: 'visible',
            transform: 'translate(0, -20px)',
            transition: 'all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97)'
        },
        '& .popover__content': {
            paddingRight: 20,
            color: '#000',
            maxHeight: 280,
            width: 'fit-content',
            minWidth: 400,
            maxWidth: '70vw',
            overflowY: 'auto',
            overflowX: 'hidden',
            '& p' :{
                margin: 0
            }
        }
    }
})
export const TextFieldBodyColumn = (props) => {
    const classes = useStyles();
    return (
        <div className={classes.popoverWrapper}>
            <div className="popover__content-wrapper">
                <div className="arrow"/>
                <div className="popover__content">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: cleanHTML(props.record.body)
                        }} />
                </div>
            </div>
            <TextField className={classes.body} dangerouslySetInnerHTML={{__html:cleanHTML(props.record.body)}} label={props.label ?? ""}/>
        </div>)
};